import React from 'react'
import './eventView.css'
import Modal from "../../components/Modal"
import "animate.css/animate.min.css"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import mentors_constants from '../../constant/mentors'
import Program from "../../components/program"

export class Mentors extends React.Component{
    constructor (args) {
		super(args)
		this.state = {
			activeItem: {},
			isShow: false
		}
	}
	togglePopUp = (item) => {
		this.setState({
			isShow: !this.state.isShow,
			activeItem: item || {}
		})
	}

    render(){
    	const { location } = this.props
        const { isShow } = this.state
        return(
        	<ContentPage>
        		<Meta title="Launch of the Winpe ProClub Mentorship Program" description="The launch of Winpe ProClub was a power-packed event that brought together powerful leaders and mentors in an interactive session with the mentees." image={"https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg"} location={location} />
	            <div className="event-wrapper">
	                <section id="team" className="pb-5">
						<div className="container" style={{fontFamily: "Lato"}}>


<h1 className="section-title h1"> Winpe ProClub Induction & Graduation Ceremony

</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Wednesday, 21st January 2026 (Mumbai Cricket Association Club, BKC, Mumbai
)</div>
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							The Winpe ProClub Mentorship Program marked an important milestone with its Induction and Graduation Ceremony held on 21 January 2026 at the Mumbai Cricket Association Club, BKC. The evening brought together <b>program advisors, mentors, graduating mentees, newly inducted participants, and alumni</b> to celebrate progress, continuity, and the collective strength of the ProClub community.<br/><br/>
The ceremony honoured the successful completion of the mentorship journey by the graduating cohort while formally welcoming the new cohort into the program, setting an energised and purposeful tone for the year ahead. Serving as an alumni meet as well, the event created meaningful opportunities for reflection, reconnection, and knowledge-sharing across cohorts.<br/><br/>
The evening was a powerful reflection of the impact of the ProClub Mentorship Program. Graduating mentees shared thoughtful reflections on the clarity, confidence, and professional direction they gained through the program, acknowledging the pivotal role played by their mentors. Mentors, in turn, spoke about the value of the engagement, recognising the mutual learning and perspective the mentorship experience brought to them.<br/><br/>
As a gesture of appreciation, mentors were presented with plaques in recognition of their commitment and contribution, while graduating mentees received mementoes commemorating the successful completion of their journey. The formal proceedings seamlessly transitioned into informal networking, where advisors, mentors, alumni, and mentees connected, exchanged insights, and strengthened relationships within the community.<br/><br/>
The atmosphere throughout the evening was marked by gratitude and shared purpose. Mentees expressed heartfelt thanks to their mentors and to Winpe for creating a platform that consistently enables growth and leadership. Advisors and mentors reaffirmed their commitment to giving back and nurturing the next generation of leaders, even amidst demanding professional responsibilities.<br/><br/>
The Winpe ProClub Mentorship Program continues to be a strong pillar of support and empowerment for women in the investing ecosystem, and the 2026 Induction and Graduation Ceremony reaffirmed its lasting impact and growing community.


 <br/>  
 <div className="gellery_section">
	            				<h1 className="section-title h1" >Gallery</h1>
	            				<div className="img_box">
	            					<div className="row">
									<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/2.jpg" alt="ProClub In Person Networking Event" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/3.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/4.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
											<div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/5.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										</div>
										 
									 	<div className="row">
									<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/6.jpg" alt="ProClub In Person Networking Event" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/7.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/8.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
											<div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/21jan2026/9.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										</div>
										 
	            				</div>
	            			</div>
							
							</div>

							<br/> 

















  <h1 className="section-title h1"> Mentees Breakfast at the Winpe Leadership Summit & Awards

</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Thursday, 20th March 2025 (Taj Lands End, Mumbai)</div>
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							Held on March 20th, this exclusive in-person breakfast brought together mentees from all cohorts of Winpe’s mentorship program. It was a warm and engaging gathering that offered a valuable opportunity to reconnect, share personal journeys, exchange learnings, and build deeper bonds over breakfast. Mentees spoke about how many of their relationships with mentors flourished and continued well beyond the program term, and shared inspiring stories of how the program had supported their career progression.
 <br/>  
 <div className="gellery_section">
	            				<h1 className="section-title h1" >Gallery</h1>
	            				<div className="img_box">
	            					<div className="row">
									<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2025/04/DSC05319-1-scaled.jpg" alt="ProClub In Person Networking Event" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2025/04/DSC05313-scaled.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2025/04/DSC05315-1-scaled.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
											<div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2025/04/DSC05311-2-scaled.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										</div>
										 
									 
	            				</div>
	            			</div>
							
							</div>

							<br/> 










                        <h1 className="section-title h1"> ProClub Graduation Ceremony</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Wednesday, 15th January 2025 (Maker Maxity, Mumbai)</div>
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							The Winpe ProClub Mentorship Program celebrated a major milestone with the graduation ceremony of Cohort 4, which also marked the launch of Cohort 5, on January 15th at Maker Maxity, Mumbai. It also served as an alumni meet, bringing together mentees, mentors, and distinguished guests to celebrate accomplishments, build connections, and inspire future growth.<br/><br/>

The event was a wonderful celebration of our unique mentorship program with mentees coming out with deep appreciation for the program and the solid impact created by their mentors in shaping their future as successful professionals. The mentors lauded the program and acknowledged its power in spurring growth for women. They also noted, in their humility as true leaders, the value that the engagement brought to them as mentors. <br/><br/>

The evening featured an enriching panel discussion on "The Evolving Leadership Agenda: Staying Relevant in the Dynamic World" which offered a compelling exploration of the challenges and opportunities shaping modern leadership. Our mentors shared their insights on how leaders can adapt their styles to meet the demands of a fast-changing work culture, emphasizing the importance of agility, emotional intelligence, and fostering inclusivity to remain effective. The conversation also delved into leveraging emerging technologies like AI and automation to drive innovation and enhance decision-making.<br/><br/>

The mentees of Cohort 4 received momentoes, as a token commemorating their successful journey through the program. And the introduction of Cohort 5 set an enthusiastic tone for the year ahead. The evening concluded with informal networking, where alumni and mentors to connected, shared experiences, and relived memories.<br/><br/>

The atmosphere at the ceremony was filled with gratitude and appreciation, with mentees expressing deep appreciation for the mentorship, heartfelt thanks to the mentors and Winpe for the opportunities provided and their support and guidance. The mentors reaffirmed their commitment of giving back and nurturing the next generation of leaders despite their demanding schedules.
The Winpe ProClub Mentorship Program remains a beacon of support and empowerment for women in the investing ecosystem, and this event truly underscored its meaningful impact.



 <br/>  
 <div className="gellery_section">
	            				<h1 className="section-title h1" >Gallery</h1>
	            				<div className="img_box">
	            					<div className="row">
									<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/15jan1.jpeg" alt="ProClub In Person Networking Event" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/15jan2.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/15jan5.jpeg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										</div>
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/15jan3.jpeg" alt="proclub dialogues event image" />
										 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
                                            <img src="https://winpeforum.com/assets/gelleryimages/15jan4.jpeg" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/15jan6.jpeg" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
                                        </div> 
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/15jan7.jpeg" alt="proclub dialogues event image" />
										 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
                                            <img src="https://winpeforum.com/assets/gelleryimages/15jan8.jpeg" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/15jan9.jpeg" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
                                        </div> 
									
	            				</div>
	            			</div>
							
							</div>

							<br/> 

						<h1 className="section-title h1">ProClub Graduation Event</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Tuesday, 28th November 2023 (St. Regis, Mumbai)</div>
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							The ProClub Event held on November 28th, 2023, at St. Regis, Mumbai, marked another significant milestone for the ProClub Mentorship program. The evening witnessed the graduation of Cohort III and onboarding of cohort IV. This in-person gathering brought together advisors, mentors, and mentees from all four cohorts, fostering valuable connections and celebrating the spirit of mentorship.
<br/><br/>
The event served as a platform for sharing experiences, exchanging ideas, and building a strong sense of community within the ProClub Mentorship program. In collaboration with Russell Reynolds Associates, the event hosted two insightful panel discussions during the event. 


 <br/>  
 <div className="gellery_section">
	            				<h1 className="section-title h1" >Gallery</h1>
	            				<div className="img_box">
	            					<div className="row">
									<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov1.JPG" alt="ProClub In Person Networking Event" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov2.JPG" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov3.JPG" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										</div>
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov4.JPG" alt="proclub dialogues event image" />
										 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
                                            <img src="https://winpeforum.com/assets/gelleryimages/proclub28nov5.JPG" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov6.JPG" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
                                        </div> 
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov7.JPG" alt="proclub dialogues event image" />
										 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
                                            <img src="https://winpeforum.com/assets/gelleryimages/proclub28nov8.JPG" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/proclub28nov9.JPG" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
                                        </div> 
									
	            				</div>
	            			</div>
							
							</div>

							<br/> 


						<h1 className="section-title h1">ProClub In Person Networking Event </h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Friday, 11th March 2022 (Maker Maxity, BKC, Mumbai)</div>
							<div className="into_text" >	
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							The event was a first in-person networking event with the ProClub Mentorship program, bringing together advisors, mentors and mentees from both the cohorts. The event was held in partnership with Russell Reynolds Associates on 11th March at Maker Maxity, BKC, Mumbai. The enthusiasm and energy was high as mentees and mentors interacted, discussed and had shared cherished moments as a virtual association turned into an in person one. The event also celebrated the graduation of Cohort 1 with mementos for both mentees and mentors. 


 <br/>  
 <div className="gellery_section">
	            				<h1 className="section-title h1">Gallery</h1>
	            				<div className="img_box">
	            					<div className="row">
									<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub11march1.jpg" alt="ProClub In Person Networking Event" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub11march2.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub11march3.jpg" alt="proclub dialogues event image" />
												 
	            							</div>
	            						</div>
										</div>
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub11march5.jpg" alt="proclub dialogues event image" />
										 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
                                            <img src="https://winpeforum.com/assets/gelleryimages/proclub11march6.jpg" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/proclub11march7.jpg" alt="proclub dialogues event image" />
											 
	            							</div>
	            						</div>
                                        </div> 
									
									
	            				</div>
	            			</div>
							
							</div>

							
							    </div> 


						<h1 className="section-title h1">ProClub Mentorship Program | Workshop with Mentors | Cohort II</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Wednesday, 18th October 2021, 3:00 PM IST</div>
							<div className="into_text" >	
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							A workshop with <span style={{fontWeight: "bold" }}>Winpe ProClub Advisor, Matangi Gowrishankar - Independent Director, Strategic Advisor & Certified Coach</span> for mentors where best practices and useful tools for mentorship were discussed, to maximize the outcomes of the mentorship engagement for both the mentees and the mentors.

 <br/> <br/>
						 
							
							</div>

							
							    </div> 


						<h1 className="section-title h1">ProClub Mentorship Program | Workshop with Mentees | Cohort II</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Wednesday, 6th October 2021, 3:00 PM IST</div>
							<div className="into_text" >	
							<div className="section_intro_text" style={{textAlign: "center"}}>      
							A workshop organized for mentees to equip them with tools and frameworks that will help them maximize the benefits and outcomes from their mentorship engagement. Get in the right frame of mind, know what to expect, and plan your learning.

 <br/> <br/>
						 
							
							</div>

							
							    </div> 

					    <h1 className="section-title h1">ProClub Launch Cohort II</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Tuesday, 28th September, 2021</div>
							<div className="into_text" >	
							<div className="section_intro_text" style={{textAlign: "center"}}>        
							The goal of a mentorship program is to help develop key talent through career development, education and learning. After the successful experience of the Winpe ProClub Mentorship Program Cohort I, Winpe is excited to announce its Cohort II of future women leaders from the PE/VC industry.

 <br/> <br/>

The power-packed 60-minute launch event brought together powerful leaders including Winpe Advisors and the mentors<br/> in an interactive one-on-one conversation with our mentees, sharing valuable insights and advice. <br/> <br/>
							<a style={{textDecoration:'underline', color: '#23527c'}} href="/proclub-launch-2">Click here</a> to view agenda. 
							
							</div>

							
							    </div> 
								<h1 className="section-title h1">ProClub Mentees End-of-Session Meeting</h1>
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Thursday, 12th August, 2021, 4:00 PM IST</div> 
							<br/><br/>
						<h1 className="section-title h1">ProClub Dialogues</h1>
							
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Friday, 21st May, 2021</div>
							<div className="into_text" >	<div className="section_intro_text" style={{textAlign: "center"}}>  ProClub Dialogs Season 1 saw mentors and mentees come together for an open chat on the characteristics of successful leaders. We heard invaluable nuggets of wisdom from the mentors and our advisor Ms. Gopinath  as they responded to questions around what differentiates leaders, how to create impact and influence people, how do successful leaders manage difficult situations and conflict, building your personal brand, coping with self doubt and failures to build adaptability and resilience and stepping up to support peers, colleagues and team members in times of crisis like now. Our mentors opened up about their own experiences as they advised mentees on how to deal with glass ceilings, stereotypes and perceptions. <br/> <br/> It was a singular learning experience for all attendees. <br/><br/><em>As one of our mentors remarked, "I have probably taken more notes than the mentees". </em>   <br/>   </div>
							</div>

						
							<br/>   <br/>  
							<h1 className="section-title h1">ProCub Mentee Meet</h1>
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Tuesday, 23rd February, 2021, 3:00 PM IST</div> 
							<br/><br/>
                            <h1 className="section-title h1">ProClub Mentors Meet</h1>
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Thursday, 4th February, 2021, 4:30 PM</div> 
							<br/><br/>
							<h1 className="section-title h1">ProClub Launch</h1>
							<div class="sub_heading" style={{fontSize:"19px", textAlign: "center", letterSpacing: "1px", paddingTop: "5px", paddingBottom:"10px", color: "black"}}>Tuesday, 6th October, 2020</div>
							<div className="into_text">
								<div className="section_intro_text" style={{textAlign: "center"}}>The Winpe ProClub Mentorship Program was launched on 6th October 2020 with Russell Reynolds Associates as the program knowledge partner. The inaugural Cohort 2020 comprises of 12 high performing women as mentees. </div>
								<div className="section_intro_text" style={{textAlign: "center"}}>The power-packed 60-minute event brought together 18 powerful leaders including Winpe Advisors Anita George, Renuka Ramnath, and Zia Mody, ProClub Advisors Ester Martinez, Matangi Gowrishankar and Shyamala Gopinath, and the 12 mentors, in an interactive session with the mentees, sharing insights and advice. <a href="/proclub-launch">Click here</a> to view agenda. </div>
							</div>
							<div className="gellery_section">
	            				<h1 className="section-title h1">Gallery</h1>
	            				<div className="img_box">
	            					<div className="row">
									<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/ProClub-18thOct.jpg" alt="proclub dialogues event image" />
												<p>Workshop with Mentors Cohort II - 18th Oct, 2021</p>
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/ProClub-6thOct.jpg" alt="proclub dialogues event image" />
												<p>Workshop with Mentees Cohort II - 6th Oct, 2021</p>
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/LaunchCohort2.jpg" alt="proclub dialogues event image" />
												<p>ProClub Launch Cohort II - 28th Sep, 2021</p>
	            							</div>
	            						</div>
										</div>
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/Dialogues1.png" alt="proclub dialogues event image" />
												<p>ProClub Dialogues - 21st May, 2021</p>
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
                                            <img src="https://winpeforum.com/assets/gelleryimages/Dialogues2.png" alt="proclub dialogues event image" />
											<p>ProClub Dialogues - 21st May, 2021</p>
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/Dialogues3.png" alt="proclub dialogues event image" />
											<p>ProClub Dialogues - 21st May, 2021</p>
	            							</div>
	            						</div>
                                        </div> <div className="row">
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/Dialogues4.png" alt="proclub dialogues event image" />
											<p>ProClub Dialogues - 21st May, 2021</p>
	            							</div>
	            						</div>
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            							<img src="https://winpeforum.com/assets/gelleryimages/Dialogues5.png" alt="proclub dialogues event image" />
											<p>ProClub Dialogues - 21st May, 2021</p>
	            							</div>
	            						</div>
                                  
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub_Screen_shots_01.jpg" alt="event images" />
												<p>ProClub Launch - 6th October, 2020</p>
	            							</div>
	            						</div> </div>
										<div className="row">
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub_Screen_shots_02.jpg" alt="event images" />
												<p>ProClub Launch - 6th October, 2020</p>
	            							</div>
	            						</div>
	            						<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								<img src="https://winpeforum.com/assets/gelleryimages/proclub_Screen_shots_04.jpg" alt="event images" />
												<p>ProClub Launch - 6th October, 2020</p>
	            							</div>
	            						</div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
	            							<div className="e_img">
	            								 
	            							</div>
	            						</div>
	            					</div> 
	            				</div>
	            			</div>

                           

	            		</div>
	            	</section>
	            </div>
	        </ContentPage>
        )
    }
}
Mentors.propTypes = {
	location: PropTypes.object
}

export default Mentors



// WEBPACK FOOTER //
// ./src/pages/events/index.js